import { useQuery } from "@tanstack/react-query"

import { getKPIRequest } from "@/api/getKPIRequest.ts"
import { Label } from "@/components/ui/label.tsx"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import type { KPIGroupRequest } from "@/types/kpiTypes.ts"

import KPIChart from "./KPIChart.tsx"

export default function KPIChartGroup({ request }: { request: KPIGroupRequest }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["kpiChartGroup", { request }],
    queryFn: () => getKPIRequest(request),
  })

  return (
    <>
      {request.kpis.map((kpi, index) => (
        <div
          className="rounded-md col-span-2 md:col-span-1 shadow-sm border min-h-[350px] p-4"
          key={index}
        >
          {isPending && <Skeleton className="w-full h-full" />}
          {data && !isPending && !isError && (
            <>
              <h2 className="text-lg font-semibold mb-1">
                {data.at(index)?.name} <i>({data.at(index)?.unit})</i>
              </h2>
              <Label className="text-muted-foreground text-[12pt]">
                {request.aggType} {kpi.aggFunction || "Total"}
              </Label>
              <KPIChart kpi={data[index]} minHeight={265} includeTarget={true} variant="line" />
            </>
          )}
          {isError && (
            <div className="text-status-bad min-h-[425px] w-full mt-[10px] font-semibold">
              Network Error
            </div>
          )}
        </div>
      ))}
    </>
  )
}
